export default {
  state: {
    layers: []
  },
  mutations: {
    ADD_CANVAS_LAYER: function ADD_CANVAS_LAYER(state, payload) {
      state.layers.push(payload);
    },
    REMOVE_CANVAS_LAYER: function REMOVE_CANVAS_LAYER(state, payload) {
      state.layers.splice(state.layers.indexOf(payload), 1);
    }
  },
  getters: {
    isExistCanvasLayers: function isExistCanvasLayers(state) {
      return state.layers.length > 0;
    }
  }
};